
import React from "react";
import { Avatar, Box, Grid, Typography, Chip, Button, Divider } from "@mui/material";
import ProjectHeaderLogo from "assets/logo/Logo2.svg"
import CreateProjectIcon from "assets/icons/Vector (4).svg";

const Headernp = ({ handleCancelClick }) => {
  return (
    <Grid container sx={{ width: "100%", margin: 0 }}>
      <Grid size={12} sx={{ width: "100%", margin: 0 }}>
        <Box sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          width: "100%",
          boxSizing: "border-box"
        }}>

          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "space-between", md: "space-between", },
            padding: { xs: "12px 16px", sm: "12px 16px", md: "12px 12px 12px 24px" },
            backgroundColor: "#f3f3f3",
            width: { xs: "auto", sm: "auto", md: "293px" },
            boxSizing: "border-box"

          }}>
            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              width: { xs: "auto", sm: "auto", md: "92px" },
              height: "30px",
            }}>
              <Avatar
                src={ProjectHeaderLogo}
                sx={{
                  width: 24,
                  height: 24,
                  bgcolor: "transparent",
                  "& img": {
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  },
                }}
              />

              <Typography sx={{
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "24px",
                letterSpacing: "-1.4%",
                fontFamily: "Outfit, sans-serif"
              }}>
                GRinfra
              </Typography>
            </Box>

            <Chip
              label="v1.2.8"
              sx={{
                height: "24px",
                fontSize: 14,
                fontWeight: 600,
                backgroundColor: "#E5E9EB",
                lineHeight: "24px",
                letterSpacing: "0.6%",
                fontFamily: "Outfit, sans-serif",
                color: "#252C32",
                borderRadius: "6px"
              }}
            />
          </Box>

          {/* Second Box - Create Project Section */}
          <Box sx={{
            backgroundColor: "#FFFFFF",
            height: "48px",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            padding: { xs: "12px 16px", sm: "12px 16px", md: "12px 16px 12px 24px" },
            boxSizing: "border-box"
          }}>
            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              height: "24px",
            }}>
              <Avatar
                src={CreateProjectIcon}
                sx={{
                  width: 24,
                  height: 24,
                  bgcolor: "transparent",
                  "& img": {
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  },
                }}
              />

              <Typography sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "24px",
                letterSpacing: "-0.6%",
                fontFamily: "Outfit, sans-serif",
                color: "#84919A"
              }}>
                Create a project
              </Typography>
            </Box>

            <Box sx={{
              height: "32px",
              minWidth: "73px",
              borderRadius: "6px",
              p: "4px 15px",
              backgroundColor: "#FF383C33",
              boxSizing: "border-box"
            }}>
              <Button
                onClick={handleCancelClick}
                sx={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "24px",
                  letterSpacing: "-0.6%",
                  fontFamily: "Outfit, sans-serif",
                  color: "#FF5F57",
                  minWidth: "auto",
                  padding: 0
                }}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "100%", backgroundColor: "#E5E9EB", height: "1px" }} />
      </Grid>
    </Grid>
  )
}

export default Headernp;